import type { WordCollection } from "../collection.types";

export const longNightCollection: WordCollection = {
  id: "long-night",
  title: "Long Night & Spark",
  icon: "weather-night",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 11, 1), // December 1st
  endDate: new Date(new Date().getFullYear(), 11, 31), // December 31st
  words: [
    "bitter",
    "brilliant",
    "ceremony",
    "clean",
    "comfort",
    "community",
    "cosmic",
    "depth",
    "family",
    "fierce",
    "flame",
    "fuel",
    "glow",
    "guide",
    "ice",
    "love",
    "mystery",
    "night",
    "secret",
    "shadow",
    "spark",
    "strength",
  ],
};
